export const HEADER_MOT_VALIDATION_REPORT = "CEEMAS MOT Validation";
export const HEADER_MOT_MANUAL_ADJUSTMENT = "CEEMAS MOT Validation";
export const HEADER_MASTER_SETTINGS = "Configuration Centre";
